import { MasterButton } from "App/Component/ui"
import { instance3, JENIS_RAWAT } from "App/constants"
import {
  defaultDateInputDisplay,
  isNull,
  oneMonthBeforeToday,
  today,
} from "App/utils/helpers"
import { startOfDay, lastOfDay } from "utils/dates"
import {
  STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
  STATUS_TRANSAKI_PENJUALAN_TUTUP,
  STATUS_TRANSAKI_PENJUALAN_KUNCI,
  STATUS_TRANSAKI_PENJUALAN_FRONT_OFFICE,
} from "./../InputPenjualan/ui"

import React from "react"

export const urlGet = "/penjualan/list"
export const urlGetExport = "/penjualan/listExportPenjualan"
export const urlDelete = "/penjualan/delete"

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  is_jurnal: 0,
  isExternal: 0,
  id_poliklinik: "",
  nama_poliklinik: "Pilih Poliklinik",
  status_pelunasan: "",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: today(),
  kelas_id: null,
  kelas_name: "Pilih Kelas",
}

export const RESET_STATE_FORM_FILTER_EXTERNAL = {
  pages: 1,
  limit: 10,
  id: "",
  isExternal: 1,
  is_jurnal: 0,
  id_poliklinik: "",
  nama_poliklinik: "Pilih Poliklinik",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: today(),
  kelas_id: null,
  kelas_name: "Pilih Kelas",
}

export const RenderStatusPembelian = ({ status }) => {
  if (status === STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Draft"}
        color={"green"}
        type="button"
        disabled
      />
    )
  } else if (status === STATUS_TRANSAKI_PENJUALAN_TUTUP) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Tutup"}
        color={"warning"}
        type="button"
        disabled
      />
    )
  } else if (status === STATUS_TRANSAKI_PENJUALAN_KUNCI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Kunci"}
        color={"lightgreen"}
        type="button"
        disabled
      />
    )
  } else if (status === STATUS_TRANSAKI_PENJUALAN_FRONT_OFFICE) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Frontoffice"}
        color={"blue"}
        type="button"
        disabled
      />
    )
  } else {
    return <p> Tidak ditemukan</p>
  }
}

export const RenderStatusJurnal = ({ status }) => {
  if (status) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Sudah Terupdate"}
        color={"green"}
        type="button"
        disabled
      />
    )
  } else {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Belum Terupdate"}
        color={"warning"}
        type="button"
        disabled
      />
    )
  }
}

export const getByFilterPenjualan = async (
  formFilter,
  pages,
  limit,
  alwaysLunas = false,
) => {
  try {
    const data = {
      halaman: pages,
      jumlah: limit,
      isExternal: formFilter.isExternal ? 1 : 0,
      id_poliklinik: formFilter.id_poliklinik,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
      kelasId: formFilter.kelas_id,
      is_jurnal: formFilter.is_jurnal,
      lunas: isNull(formFilter.status_pelunasan)
        ? ""
        : parseInt(formFilter.status_pelunasan) === 1
        ? false
        : true,
    }

    for (const key in data) {
      if (isNull(data[key])) {
        delete data[key]
      }
    }

    const katPencarianData = {
      0: "semua",
      1: "id_kunjungan",
      2: "id_penjualan",
      3: "id_rm",
      4: "nama_rm",
    }

    const katPencarian = katPencarianData[formFilter.kategori_pencarian]

    const kataKunci =
      katPencarian !== "semua"
        ? {
            [katPencarian]: formFilter.kata_kunci,
          }
        : {}

    const api = alwaysLunas
      ? await instance3.post(urlGet, {
          ...data,
          ...kataKunci,
          lunas: true,
        })
      : await instance3.post(urlGet, {
          ...data,
          ...kataKunci,
        })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterPenjualanExport = async (formFilter) => {
  try {
    const data = {
      isExternal: formFilter.isExternal ? 1 : 0,
      id_poliklinik: formFilter.id_poliklinik,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
      kelasId: formFilter.kelas_id,
      is_jurnal: formFilter.is_jurnal,
      lunas: isNull(formFilter.status_pelunasan)
        ? ""
        : parseInt(formFilter.status_pelunasan) === 1
        ? false
        : true,
    }

    const katPencarianData = {
      0: "semua",
      1: "id_kunjungan",
      2: "id_penjualan",
      3: "id_rm",
      4: "nama_rm",
    }

    const katPencarian = katPencarianData[formFilter.kategori_pencarian]

    const kataKunci =
      katPencarian !== "semua"
        ? {
            [katPencarian]: formFilter.kata_kunci,
          }
        : {}

    const api = await instance3.post(urlGetExport, {
      ...data,
      ...kataKunci,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const addInsuranceAndKelasToListBarang = (
  arr,
  kelas_id,
  asuransi_id,
) => {
  const newArr = []
  arr.map((item) => {
    const newItem = {
      ...item,
      harga: isNull(item.harga) ? 0 : item.harga,
      hargaCustom: isNull(item.hargaCustom) ? 0 : item.hargaCustom,
      total: isNull(item.harga) ? 0 : item.qty * item.hargaCustom,
      kelas_id,
      asuransi_id,
    }

    return newArr.push(newItem)
  })

  return newArr
}

export const addTotalToItemArray = (arr) => {
  const newArr = []
  arr.map((item) => {
    const newItem = {
      ...item,
      total: item.qty * item.hargaCustom,
    }

    return newArr.push(newItem)
  })

  return newArr
}

export const getByID = async (id) => {
  try {
    const res = await instance3.get(`/penjualan/detailsById/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data[0],
      }
    } else {
      return {
        state: false,
        data: {},
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
    }
  }
}

export const getDiskonByInsurance = async (idAsuransi) => {
  try {
    const res = await instance3.get(`/penjualan/get-diskon-asuransi`, {
      params: {
        id_asuransi: idAsuransi,
      },
    })
    if (res.data?.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        data: {},
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
    }
  }
}

export const deleteByID = async (id) => {
  try {
    const api = await instance3.post(urlDelete, {
      id,
    })

    if (api.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      }
    } else {
      return {
        state: false,
        message: api.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id_kunjungan",
    disablePadding: false,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tagihanIdKunj",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "rm_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "nama_rm",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "lunas",
    disablePadding: false,
    label: "LUNAS",
    align: "left",
    sort: false,
  },
  {
    id: "status_transaksi",
    disablePadding: false,
    label: "STATUS TRANSAKSI",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "is_jurnal",
    disablePadding: false,
    label: "STATUS JURNAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaDokter",
    disablePadding: false,
    label: "NAMA DOKTER",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "poliklinik",
    disablePadding: false,
    label: "POLIKLINIK",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "id_jenis_layanan",
    disablePadding: false,
    label: "JENIS LAYANAN",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "unit_id",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "insurance_id",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "namaMsPembayaran",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "harga_total_barang",
    disablePadding: false,
    label: "JML BARANG",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "harga_total_jasa",
    disablePadding: false,
    label: "JML JASA",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "harga_total_fasilitas",
    disablePadding: false,
    label: "JML FASILITAS",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "harga_total_rikjang",
    disablePadding: false,
    label: "JML RIKJANG",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "harga_total_paket",
    disablePadding: false,
    label: "JML PAKET",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "jumlah_tax",
    disablePadding: false,
    label: "TAX",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "jumlah_set_discount",
    disablePadding: false,
    label: "POTONGAN",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "total",
    disablePadding: false,
    label: "TOTAL",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

const ID_TYPE_OF_CARE = {
  IGD: 1,
  RAJAL: 2,
  RANAP: 3,
}

export const getDataEditPenjualan = async (
  row,
  tagihanIDKey = "tagihanIdKunj",
  diskon,
) => {
  const res = await getByID(row.id)

  if (res.state) {
    const propsPageInputPenjualan = {
      penjualan_id: res.data.id,
      idExt: res.data.id,
      date: defaultDateInputDisplay(res.data.date, true),

      is_jurnal: row.is_jurnal,

      status_transaksi: row.status_transaksi,
      id_type_of_care: res.data.id_type_of_care,
      asuransi_id: res.data.insurance_id,
      asuransi: res.data.namaAsuransi,
      noasuransi: res.data.insurance_no,

      kelas_id: res.data.id_kelas,
      kelas_name: res.data.namaKelas,

      kunjungan_id: res.data.id_kunjungan,

      tipe_pembayaran_id: res.data.msTipePembayaranId,
      // tipe_pembayaran_name: res.data.namaTipePembayaran,

      jenis_layanan_id: res.data.id_jenis_layanan,
      jenis_layanan_name: res.data.jenis_layanan_name,

      kas_bank_id: res.data.kas_id,
      kas_bank_name: res.data.namaKas,

      gudang_id: row.gudang_id,
      gudang_name: row.namaGudang,

      is_lock: res.data.is_lock,
      tgl_lock: res.data.tgl_lock,

      is_close: res.data.is_close,
      tgl_close: res.data.tgl_close,

      isUpdate: true,

      rm_id: res.data.id_rm,
      jenisrm: 2,
      type: "update",
      petugas: res.data.petugas,
      dokter_id: res.data.id_dokter,
      dokter_name: res.data.namaDokter,
      is_external: res.data.isExternal,

      // RM External
      nama: res.data.isExternal ? res.data.namaRMExt : res.data.nama_rm,
      tagihan_id: res.data.isExternal ? row.tagihanIdExt : row[tagihanIDKey],
      keterangan: res.data.keterangan,
      intext: isNull(res.data.intext) ? 1 : res.data.intext,

      fasilitas: addTotalToItemArray(res.data.fasilitas),
      jasa: addTotalToItemArray(res.data.jasa),
      rikjang: addTotalToItemArray(res.data.rikjang),
      barang: addInsuranceAndKelasToListBarang(
        res.data.barang,
        res.data.id_kelas,
        res.data.insurance_id,
      ),
      paket: addTotalToItemArray(res.data.paket),

      potongan: res.data.jumlah_set_discount,

      potongan2: res.data.jumlah_set_discount,
      pembayaran: res.data.bayar_jual,

      tax_percent: res.data.tax,
      tax: res.data.tax,

      diskon: diskon,
    }
    return propsPageInputPenjualan
  }
  return res.data
}
